import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/illus-home.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-between mb-4 mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg mb-3" }, "Meetings Schedule ")
], -1)
const _hoisted_2 = { class: "flex flex-row justify-end items-cente" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_5 = { class: "flex p-3" }
const _hoisted_6 = { class: "flex flex-row justify-between items-start w-full" }
const _hoisted_7 = { class: "w-full flex flex-col" }
const _hoisted_8 = { class: "text-gray-600 text-lg font-semibold" }
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Created & sent by: ")
const _hoisted_11 = { class: "font-medium text-gray-500" }
const _hoisted_12 = { class: "text-gray-500 italic" }
const _hoisted_13 = { class: "hover cursor-pointer relative" }
const _hoisted_14 = {
  key: 0,
  class: "h-6 w-6 text-gray-400 animate-spin",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"6\"></line><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"22\"></line><line x1=\"4.93\" y1=\"4.93\" x2=\"7.76\" y2=\"7.76\"></line><line x1=\"16.24\" y1=\"16.24\" x2=\"19.07\" y2=\"19.07\"></line><line x1=\"2\" y1=\"12\" x2=\"6\" y2=\"12\"></line><line x1=\"18\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"4.93\" y1=\"19.07\" x2=\"7.76\" y2=\"16.24\"></line><line x1=\"16.24\" y1=\"7.76\" x2=\"19.07\" y2=\"4.93\"></line>", 8)
const _hoisted_23 = [
  _hoisted_15
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "1"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "19",
  r: "1"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "5",
  r: "1"
}, null, -1)
const _hoisted_29 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 2,
  class: "w-64 shadow-menu absolute right-0 p-2 rounded-lg bg-white z-50"
}
const _hoisted_31 = { class: "bg-white w-full space-y-3" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6 text-gray-500 mr-3\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\"></path><path d=\"M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3\"></path><path d=\"M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3\"></path><line x1=\"16\" y1=\"5\" x2=\"19\" y2=\"8\"></line></svg><span>Edit</span>", 2)
const _hoisted_35 = [
  _hoisted_33
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-gray-500 mr-3",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "22",
    y1: "2",
    x2: "11",
    y2: "13"
  }),
  /*#__PURE__*/_createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "Re-send meeting", -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-pink-500 mr-3",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", null, "Deactivate", -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  key: 0,
  class: "w-full p-2 flex flex-col items-center"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "160",
  alt: ""
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mt-6 font-medium" }, "No meetings scheduled yet", -1)
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  class: "mt-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ModalScheduleMeeting = _resolveComponent("ModalScheduleMeeting")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          variant: "contained",
          label: "Schedule a meeting",
          onOnClick: _ctx.createMeeting
        }, {
          startIcon: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onOnClick"])
      ]),
      (!_ctx.loadingMeetings)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetings, (meeting, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "shadow-box-card border border-gray-100 rounded-lg p-1 my-4",
                key: index
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h1", _hoisted_8, _toDisplayString(meeting.title), 1),
                      _createElementVNode("small", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("strong", _hoisted_11, _toDisplayString(meeting.user.user_name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(meeting.url), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (meeting.id === _ctx.activeMenu && _ctx.deleteMeeting === true)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_23))
                        : (_openBlock(), _createElementBlock("svg", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.showMenu(meeting.id)),
                            class: "h-6 w-6 text-gray-500",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            "stroke-width": "2",
                            stroke: "currentColor",
                            fill: "none",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, _hoisted_29, 8, _hoisted_24)),
                      (meeting.id === _ctx.activeMenu)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              (_ctx.userId === meeting.user.id)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.editMeeting(meeting.id)),
                                    class: "flex flex-row py-3 px-2 w-full rounded hover:bg-gray-100"
                                  }, _hoisted_35, 8, _hoisted_32))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.reSendMeeting(meeting.id)),
                                class: "flex flex-row py-3 px-2 w-full rounded hover:bg-gray-100"
                              }, _hoisted_39, 8, _hoisted_36),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.deleteMeeting(meeting.id)),
                                class: "flex flex-row py-3 px-2 w-full rounded hover:bg-gray-100"
                              }, _hoisted_43, 8, _hoisted_40)
                            ])
                          ])), [
                            [_directive_click_away, _ctx.closeMenu]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.meetings.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_47))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_48, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2], (item, index) => {
              return _createElementVNode("div", { key: index }, [
                _createVNode(_component_Skeleton, { option: "card-meeting" })
              ])
            }), 64))
          ]))
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setshowModal(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalScheduleMeeting, {
          onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setshowModal(false))),
          onReloadMeetings: _ctx.getCandidateMeetings,
          jobId: _ctx.jobCandidate.job_id,
          candidateId: _ctx.jobCandidate.id,
          meetingId: _ctx.meetingId
        }, null, 8, ["onReloadMeetings", "jobId", "candidateId", "meetingId"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}